module.exports = __webpack_public_path__ + "static/media/Accepted.45c43c6e.png";